const WorkoutDeleteType = {
  WORKOUT: 'WORKOUT',
  MULTIPLE_WORKOUTS: 'MULTIPLE_WORKOUTS',
  PROGRAM: 'PROGRAM',
};

export {
  WorkoutDeleteType,
};
